import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 2rem 1rem 1rem 1rem;
  margin-top: 0.5rem;

  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

export const WrapperButtons = styled(Grid)`
  button:not(:first-child) {
    margin-top: 1.5rem;
  }
`;
